import { render, staticRenderFns } from "./TestPlanAuditLog.vue?vue&type=template&id=a9f031a4"
import script from "./TestPlanAuditLog.vue?vue&type=script&lang=js"
export * from "./TestPlanAuditLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports